import React, { useState, useMemo, useEffect } from "react";
import { Col, Modal, Row } from "antd";
import axios from "axios";
import moment from "moment";
import "./KalenderTuerchen.scss";
import "./KalenderTuerchenMobile.scss";
import "moment/locale/de";
import Tuerchen from "./Tuerchen";
import TeilnahmeModal from "./TeilnahmeModal";
import { CalenderConfig } from "../../App";

const Kalender = ({ config }: { config: CalenderConfig }) => {
  const currentDate = moment(config.currentDate);

  const [currentDateTuerchenOffen, setCurrentDateTuerchenOffen] =
    useState(false);

  const [tuerchenInhalte, setTuerchenInhalte] = useState([]);

  const [showTeilnahmeModal, setShowTeilnahmeModal] = useState(false);

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const tuerchenOrder = useMemo(
    () => Array.from(Array(24).keys()).sort(() => Math.random() - 0.5),
    []
  );

  const [loading, setLoading] = useState(false);

  const loadAlleTuerchen = async () => {
    setLoading(true);
    try {
      const { error, tuerchen, isLoggedIn } = (
        await axios.get(
          `${process.env.REACT_APP_SUB_DIR}api/public/alleTuerchen.php`
        )
      ).data;

      if (error) {
        Modal.error({ content: error });
      } else {
        setTuerchenInhalte(tuerchen);
        setIsLoggedIn(isLoggedIn || false);
      }
    } catch (err: any) {
      console.error("error", err.message);
    } finally {
      setLoading(false);
    }
  };

  // alle Tuerchen laden
  useEffect(() => {
    loadAlleTuerchen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="header">
        <h1>
          <span className="shopping-center-name">
            {config.shoppingCenterName}
          </span>
          <br />
          Adventkalender
        </h1>
        <img
          src={`${process.env.PUBLIC_URL}/img/logo/${config.logoName}`}
          alt={`Logo ${config.shoppingCenterName}`}
          title={`Logo ${config.shoppingCenterName}`}
          className="logo"
        />
      </div>

      <Row
        className={`kalender-wrapper ${showTeilnahmeModal ? "fade-out" : "fade-in"
          }`}
      >
        {currentDate.month() === 11 && currentDate.date() <= 24 && (
          <Col span={24}>
            <div className="current-date">
              <h2>Jetzt folgendes Türchen öffnen:</h2>
              <Row
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Tuerchen
                  day={currentDate.date()}
                  content={
                    (tuerchenInhalte && tuerchenInhalte[currentDate.date()]) ||
                    null
                  }
                  designName={config.designName || ""}
                  isBig
                  defaultOpen={false}
                  currentDate={currentDate}
                  allowTeilnahme
                  onClick={() => {
                    setCurrentDateTuerchenOffen(!currentDateTuerchenOffen);
                  }}
                  onTeilnahmeClick={() => {
                    setShowTeilnahmeModal(true);
                  }}
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  xxl={12}
                />
              </Row>
            </div>
          </Col>
        )}
        <Col
          xs={{ span: 24 }}
          sm={{ span: 20 }}
          md={{ span: 20 }}
          xl={{ span: 20 }}
          xxl={{ span: 18 }}
          style={{ flex: "none" }}
        >
          {loading ? (
            <p style={{ color: "white" }} className="fade-in">
              Laden ...
            </p>
          ) : (
            <Row gutter={[48, 8]} className="kalender-tuerchen-wrapper fade-in">
              {tuerchenOrder.map((k) => (
                <Tuerchen
                  key={k}
                  day={k + 1}
                  content={(tuerchenInhalte && tuerchenInhalte[k + 1]) || null}
                  designName={config.designName || ""}
                  isBig={false}
                  currentDate={currentDate}
                  allowTeilnahme={isLoggedIn}
                  onTeilnahmeClick={() => {
                    setShowTeilnahmeModal(isLoggedIn && true);
                  }}
                  xs={12}
                  sm={12}
                  md={8}
                  lg={6}
                  xl={6}
                  xxl={4}
                />
              ))}
            </Row>
          )}
        </Col>
      </Row>

      <TeilnahmeModal
        open={showTeilnahmeModal}
        content={
          (tuerchenInhalte && tuerchenInhalte[currentDate.date()]) || null
        }
        onClose={() => {
          setShowTeilnahmeModal(false);
        }}
        teilnahmebedingungenEmail={config.teilnahmebedingungenEmail}
        teilnahmebedingungenUrl={config.teilnahmebedingungenUrl}
      />
    </>
  );
};

export default Kalender;
